import { Modal } from "antd";
import PropTypes from "prop-types";
const LogoutPopup = ({
  isModal,
  setIsModal,
  cancel,
  title,
  logout,
  deactivate,
  onClick,
}) => {
  LogoutPopup.propTypes = {
    isModal: PropTypes.bool,
    setIsModal: PropTypes.bool,
    cancel: PropTypes.any,
    title: PropTypes.string,
    logout: PropTypes.any,
    deactivate: PropTypes.any,
    onClick: PropTypes.func,
  };
  return (
    <div>
      <Modal
        closable={false}
        width={300}
        open={isModal}
        onOk={() => setIsModal(false)}
        onCancel={() => setIsModal(false)}
        destroyOnClose
        centered
        footer={null}
      >
        <div>
          <h2 className="text-center text-base font-medium ">{title}</h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <button
              onClick={() => setIsModal(false)}
              className="px-4 py-2 rounded-2xl text-sm text-[#8A8A8A] border border-[#00000014]"
            >
              {cancel}
            </button>
            <button
              onClick={onClick}
              className="px-4 py-2 rounded-2xl text-sm text-[#fff] border bg-[#FE6B01]"
            >
              {deactivate ?? logout}
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LogoutPopup;
